export default "__VITE_ASSET__7a9c87c2__"